import { render } from "./MenuSidebar.vue?vue&type=template&id=691d4bb2&scoped=true"
const script = {}

import "./MenuSidebar.vue?vue&type=style&index=0&id=691d4bb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691d4bb2"]])

export default __exports__